import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const KopVersionControl = React.lazy(async () => ({
    default: (await import('@oc/kop-version-control/module')).VersionControlModule
}))

export function KopVersionControlComponent() {
    return <SuspenseWhileLoading LazyComponent={KopVersionControl} />
}
